import {
  showContentLockedBottomSheetAction,
  showCourseLockedBottomSheetAction,
  showLockedFreeCourseBottomSheetAction,
  showViewsExhaustedBottomSheetAction,
  toggleVideoBottomSheet
} from "@src/components/BottomSheets/store/actions";
import { getAwsAssets, hitHapticFeedback } from "@src/utils";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";
import { hitDeeplinkExecutedV2 } from "@src/utils/hitDeeplink";
import { t } from "i18next";
import Linkify from "linkify-react";
import { Image } from "@src/components/Image";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { installmentsAlertStateEnum } from "../../../Overview/store/constants";
import getContentThumbnail from "../../helpers/getContentThumbnail";
import handleOpenContent from "../../helpers/handleOpenContent";
import isContentDownloadable from "../../helpers/isContentDownloadable";
import isVideoExhausted from "../../helpers/isVideoExhausted";
import styles from "../../styles/FeaturedVideo.module.scss";
// import ContentDownloader from "../ContentList/ContentDownloader";
// import VideoContentCases from "../ContentList/VideoContentCases";
// import VideoProgressBar from "../ContentList/VideoProgressBar";
import { getUserAgent } from "@src/utils/getAxiosConfig";
import { USER_AGENT_STRING } from "@src/utils/constants";
import { CONTENT_TYPE } from "../../store/constants";
import { safeJsonParse } from "@src/utils/safeJsonParse";

import ContentDownloader from "../ContentList/ContentDownloader";
import VideoContentCases from "../ContentList/VideoContentCases";
import VideoProgressBar from "../ContentList/VideoProgressBar";

const FeaturedVideo = ({
  videoItem,
  expandedDesc,
  getOfflineDownloadedItemProgress,
  getOfflineDownloadedItemState,
  handleGetOfflineDownloadList,
  handleSetCheckProgressInterval,
  handleClearCheckProgressInterval,
}) => {
  const [descriptionExpanded, setDescriptionExpanded] = React.useState(
    expandedDesc || false
  );

  // REDUX DISPATCH
  const dispatch = useDispatch();

  // FETCHING STATES FROM REDUCER
  const isCourseLocked = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.installments
        ?.installmentAlertState
  );


  const orgId = useSelector((state) => state?.overviewReducer?.overViewDetails?.course
  ?.metaData?.orgId) ;

  // FUNCTION TO EXPANF DESCRIPTION OF VIDEO CONTENT
  const handleReadMoreClicked = () => {
    setDescriptionExpanded(!descriptionExpanded);
  };
  const isFreeCourse = useSelector((state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.isFreeCourse) || 0;
  const isUserSubscribedToFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isUserSubscribedToFreeCourse
    ) || 0;
  const canRePurchaseFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.canRePurchaseFreeCourse
    );

  // FUNCTION TO HANDLE VIDEO PLAY
  const handleVideoClicked = (content) => {
    localStorage.setItem("currentItem", JSON.stringify(content));

    if (
      isCourseLocked === installmentsAlertStateEnum.COURSE_LOCKED &&
      content?.isLocked
    ) {
      dispatch(showCourseLockedBottomSheetAction(true));
      return;
    }
    if (content?.isLocked) {
      if(isFreeCourse && (isUserSubscribedToFreeCourse || !canRePurchaseFreeCourse)){
        dispatch(showLockedFreeCourseBottomSheetAction(true));
      }else{
        dispatch(showContentLockedBottomSheetAction(true));
      }
    }
    // IF VIDEO LIMIT IS EXHAUSTED OPENING EXHAUSTED BOTTOMSHEET
    else if (isVideoExhausted(content)) {
      dispatch(showViewsExhaustedBottomSheetAction(true));
    } else {
      const isMobileAndroid = getUserAgent() === USER_AGENT_STRING.ANDROID;
      const isCorruptedAndroidVersion = safeJsonParse(window?.androidData, {
        source: "FeaturedVideo [window.androidData]",
        fallback: null,
      });
      console.log(isCorruptedAndroidVersion, 'isCorruptedAndroidVersion');
      const enableWebVideoPlayer = isMobileAndroid && isCorruptedAndroidVersion?.appVersion === "1.6.1.3";

      if (content.contentType === CONTENT_TYPE.VIDEO && enableWebVideoPlayer) {
          dispatch(toggleVideoBottomSheet({
                value: true,
                data: content
              }));
      }
      else {
        handleOpenContent(videoItem);

      }
    }
  };

  const isPurchased = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased
  );

  const linkProps = {
    onClick: (e) => {
      e?.preventDefault();
      hitHapticFeedback();
      hitDeeplinkExecutedV2(
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: e?.nativeEvent?.target?.innerText,
        }),
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: e?.nativeEvent?.target?.innerText,
        })
      );
    },
  };

  return (
    <div className={styles.featuredVideo}>
      <div
        className={styles.newFeatureVideo}
        onClick={() => handleVideoClicked(videoItem)}
      >
        <div
          className={
            videoItem?.isLocked || isVideoExhausted(videoItem)
              ? styles.newFeatureVideo__lockedVideo
              : styles.newFeatureVideo__unlockedVideo
          }
        ></div>
        <img
          src={getContentThumbnail(videoItem)}
          className={styles.newFeatureVideo__image}
        />
        <div className={styles.newFeatureVideo__thumbnailImage}>
          {videoItem?.isLocked || isVideoExhausted(videoItem) ? (
            <Image
              src={getAwsAssets("lockIconWhite.svg", "content")}
              alt="playIcon"
            />
          ) : (
            <Image
              src={getAwsAssets("playIcon.svg", "content")}
              alt="playIcon"
            />
          )}
        </div>
      </div>
      {/* <div
        className={`${styles.featuredVideo__thumbnail} ${
          (videoItem?.isLocked || isVideoExhausted(videoItem)) &&
          styles["featuredVideo__thumbnail--exhausted"]
        }`}
        style={{ background: `url(${getContentThumbnail(videoItem)})` }}
        onClick={() => handleVideoClicked(videoItem)}
      >
        <div className={styles.featuredVideo__thumbnail__playContainer}>
          {videoItem?.isLocked || isVideoExhausted(videoItem) ? (
            <Image
              src={getAwsAssets("lockIconWhite.svg", "content")}
              alt="playIcon"
              width={32}
              height={42}
            />
          ) : (
            <Image
              src={getAwsAssets("playIcon.svg", "content")}
              alt="playIcon"
              width={27}
              height={27}
            />
          )}
        </div>
      </div> */}
      <VideoProgressBar
        lastSeek={videoItem?.lastSeek}
        duration={videoItem?.duration}
        videoMaxDuration={videoItem?.videoMaxDuration}
        featuredVideo
      />
      <div className={styles.featuredVideo__info}>
        <div className={styles.featuredVideo__info__header}>
          <h5>{videoItem?.name}</h5>
          {isContentDownloadable(videoItem) &&
            getOfflineDownloadedItemProgress &&
            getOfflineDownloadedItemState && (
              <ContentDownloader
                content={videoItem}
                getOfflineDownloadedItemProgress={
                  getOfflineDownloadedItemProgress
                }
                getOfflineDownloadedItemState={getOfflineDownloadedItemState}
                handleGetOfflineDownloadList={handleGetOfflineDownloadList}
                handleSetCheckProgressInterval={handleSetCheckProgressInterval}
                handleClearCheckProgressInterval={handleClearCheckProgressInterval}
              />
            )}
        </div>
        <VideoContentCases content={videoItem} />
        {videoItem?.description &&
          (isPurchased ? (
            <Linkify options={{ attributes: linkProps }}>
              <h6
                className={`${styles.featuredVideo__info__description} ${
                  !descriptionExpanded &&
                  styles[`featuredVideo__info__description--collapsed`]
                }`}
              >
                {videoItem?.description}
              </h6>
            </Linkify>
          ) : (
            <h6
              className={`${styles.featuredVideo__info__description} ${
                !descriptionExpanded &&
                styles[`featuredVideo__info__description--collapsed`]
              }`}
            >
              {videoItem?.description}
            </h6>
          ))}
        {videoItem?.description &&
        videoItem?.description?.length > 95 &&
        !expandedDesc ? (
          <React.Fragment>
            {descriptionExpanded ? (
              <p onClick={handleReadMoreClicked}>
                {t(
                  "components.tabs.content.components.contentHome.featuredVideo.readLessText",
                  "Read Less"
                )}
              </p>
            ) : (
              <p onClick={handleReadMoreClicked}>
                {t(
                  "components.tabs.content.components.contentHome.featuredVideo.readMoreText",
                  "Read More"
                )}
              </p>
            )}
          </React.Fragment>
        ) : null}
      </div>
    </div>
  );
};

export default FeaturedVideo;
